import React, { ComponentType } from 'react';
import ReactMarkdown from 'react-markdown';
import { Container } from '@uds/grid';
import PaddingBox from '@uds/padding-box';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import visibilitySet from 'presentation/hocs/visibilitySet';
import errorBoundary from 'presentation/hocs/errorBoundary';
import Ribbon from 'components/ribbons/Ribbon';

import renderers from './renderers';

interface OuterProps extends RibbonProps {
  document: string;
}
const PureLegalDocument = ({ id, colorway, loading, layout, document, name }: OuterProps) => {
  const themedRenderers = renderers({ colorway });

  return (
    <Ribbon id={id} layout={layout} colorway={colorway} loading={loading} name={name} type={Type.LEGAL_DOCUMENT}>
      <Container>
        <PaddingBox>
          <ReactMarkdown source={document} renderers={themedRenderers} />
        </PaddingBox>
      </Container>
    </Ribbon>
  );
};

PureLegalDocument.displayName = 'LegalDocument';

export default errorBoundary(visibilitySet(PureLegalDocument)) as ComponentType<OuterProps>;
